var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A2A2A0",
    d: "M1332 332L1328.667 332 1328.667 327 1324 334 1327.333 334 1327.333 339z",
    transform: "translate(-1324 -327)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillIcon);
export default __webpack_public_path__ + "static/media/skill-icon.30fd480d8b468e83e1a9a354f5527bfe.svg";
export { ForwardRef as ReactComponent };